import { mapConfigs } from "../../../config/map";

export function isInRange(userLocation) {
    const boundaries = mapConfigs.AutoCompleteBoundaries;
    if (userLocation == null) return false;
    if (
    userLocation.lat < boundaries.north &&
    userLocation.lat > boundaries.south &&
    userLocation.lng < boundaries.east &&
    userLocation.lng > boundaries.west
    ) {      return true;    }
    return false;
}
